export default "__VITE_ASSET__a6f2aabd__"